import { Component } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { MessageService, ConfirmationService } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../../../services/auth.service';
import { SupervisorService } from 'src/app/services/supervisor.service';
//import { Supervisor } from '../../../../models/supervisor.interface';
import { PendientePorAsignar } from 'src/app/models/pendiente-asignar.interface';
import { Paginar } from 'src/app/models/http-paginacion.interface';
//import { AsignacionEnfermeraCasoclinicoComponent } from 'src/app/dialogs/asignacion-enfermera-casoclinico/asignacion-enfermera-casoclinico.component';
import { Enfermera } from 'src/app/models/enfermera.interface';
import { CasoClinico } from 'src/app/models/caso-clinico.interface';
@Component({
  selector: 'app-supervisor-pendientes-asignar',
  templateUrl: './supervisor-pendientes-asignar.component.html',
  styleUrls: ['./supervisor-pendientes-asignar.component.scss'],
  providers: [DialogService, DynamicDialogConfig, DynamicDialogRef, MessageService, ConfirmationService]

})
export class SupervisorPendientesAsignarComponent {
  idSupervisor: number = 0;
  pendientesPorAsignar: PendientePorAsignar[] = [];
  pendientesPorAsignarTmp: PendientePorAsignar[] = [];
  currentPageCasosClinicos: Paginar = { page: 0,  first: 0,  rows: 10, pageCount: 0 };
  totalItemsCasosClinicos: number = 10;
  enfermeraForm!: FormGroup;
  asignacionEnfermeraCasoclinicoRef: DynamicDialogRef | undefined;
  
  catalogoEnfermeras: Enfermera[] =[];
  showModal = false;
  modalTitle = '';
  modalMessage = '';
  accionPendiente: 'cancelar' | 'rechazar' | null = null;

  constructor(private supervisorService: SupervisorService, 
              private authService: AuthService, 
              private fb: FormBuilder, 
              private dialogService: DialogService,
              private messageService: MessageService, 
              private confirmationService: ConfirmationService ){
    
                this.enfermeraForm = this.crearFormulario();            
    if(this.authService.isLoggedIn) {
        const id: number | undefined = this.authService.getUsuario?.supervisor?.id;
        if(id) this.obtenerInformacion(id);
    }

  }
  crearFormulario(): FormGroup {
    return this.fb.group({
      enfermera: [null, Validators.required],
      fk_casoclinico: [null]
    })
  }
  obtenerInformacion(id: number): void {
    this.idSupervisor = id;
    this.supervisorService.getPendientesPorAsignar(id)
    .subscribe({
      next:(resp)=>{ 
        this.pendientesPorAsignar = resp; 
        this.pendientesPorAsignarTmp.push(...resp);
      },
      error:(err: HttpErrorResponse)=>{ this.showError(err.error.message) }
    })
  }


  asignarEnfermeraCasoClinico(fk_casoclinico: number, fk_medico: number): void {
    this.enfermeraForm.get('fk_casoclinico')?.setValue(fk_casoclinico);
    this.supervisorService
    .getCatalogoEnfermerasXAsignarCC(fk_medico, this.idSupervisor)
    .subscribe({
      next:(resp)=> { 
        this.modalEnfermeras(resp.datos, fk_casoclinico);      
      },
      error:(err: HttpErrorResponse)=> {this.showError(err.error.message)}
    })
  }

  modalEnfermeras(enfermeras: Enfermera[], fk_casoclinico: number): void {
  this.catalogoEnfermeras = enfermeras;
  this.openModal();
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

  onSubmit(): void{
    const enfermera: Enfermera = this.enfermeraForm.get('enfermera')?.value;
    const fk_casoclinico = this.enfermeraForm.get('fk_casoclinico')?.value;
    console.log(enfermera, fk_casoclinico);
    
    this.supervisorService.asociarEnfermeraCasoClinico(enfermera.id, fk_casoclinico)
    .subscribe({
      next: (resp)=> {                       
            this.showSuccess(resp.mensaje);
            this.reorganizarPendientes(resp.datos);
      },
      error: (err: HttpErrorResponse)=> { this.showError(err.error.message) }
    })
    
  }
  reorganizarPendientes(casoclinico: CasoClinico): void{
    this.pendientesPorAsignarTmp = this.pendientesPorAsignarTmp.filter((item)=> item.id != casoclinico.id);
    this.closeModal();
  }
  cancelarAccion(): void {
    this.resetForm();
    this.catalogoEnfermeras = [];
    this.closeModal();    
  }

  closeModal(): void {
    this.showModal = false;
    this.accionPendiente = null;
  }
  openModal(): void{
    this.accionPendiente = 'rechazar';
    this.showModal = true;
  }
  resetForm(): void {
    this.enfermeraForm.reset();
  }
 
}
